export default __webpack_public_path__ + "static/media/2.f6d3cfc7.jpeg";